/**
 * Fiche produit Klapi App.
 *
 * - Formulaire [data-klapi-ajout] : les radios de formule mettent à jour la variante, le plan
 *   d'abonnement (selling_plan), le prix affiché et l'URL (?variant=). L'envoi ajoute au panier
 *   sans recharger (Ajax API) puis ouvre le tiroir panier.
 * - Boutons [data-ajout-variante="id"] (section Formules) : ajoutent directement cette formule.
 * - Galerie [data-klapi-galerie] : les vignettes font défiler le slider et suivent la slide active.
 *
 * Le panier est mis à jour par l'événement `klapi:panier` (voir klapi-panier.js).
 * Une seule quantité par formule : si la formule est déjà au panier, on ouvre simplement le tiroir.
 */
(() => {
  if (window.klapiProduit) return;
  window.klapiProduit = true;

  const annoncer = (detail) => document.dispatchEvent(new CustomEvent('klapi:panier', { detail }));

  async function ajouter(id, plan, declencheur) {
    const panier = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json());
    if (panier.items.some((ligne) => String(ligne.variant_id) === String(id))) {
      annoncer({ ouvrir: true, panier, declencheur });
      return;
    }
    const corps = { items: [{ id: Number(id), quantity: 1, ...(plan ? { selling_plan: Number(plan) } : {}) }] };
    const reponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corps),
    });
    const resultat = await reponse.json();
    if (!reponse.ok) throw new Error(resultat.description || resultat.message || "L'ajout au panier a échoué.");
    annoncer({ ouvrir: true, declencheur });
  }

  /* Formulaire d'achat */
  document.querySelectorAll('[data-klapi-ajout]').forEach((form) => {
    const champId = form.querySelector('[data-variante-id]');
    const champPlan = form.querySelector('[data-plan]');
    const section = form.closest('section');
    const prixValeur = section?.querySelector('[data-prix-valeur]');
    const prixSuffixe = section?.querySelector('[data-prix-suffixe]');
    const erreur = form.querySelector('[data-erreur]');

    form.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        champId.value = radio.value;
        champPlan.value = radio.dataset.plan || '';
        champPlan.disabled = !radio.dataset.plan;
        if (prixValeur) prixValeur.textContent = radio.dataset.prixLibelle;
        if (prixSuffixe) prixSuffixe.textContent = radio.dataset.prixSuffixe;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url);
      });
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const bouton = form.querySelector('[type="submit"]');
      bouton.setAttribute('aria-busy', 'true');
      bouton.disabled = true;
      erreur.hidden = true;
      try {
        await ajouter(champId.value, champPlan.disabled ? '' : champPlan.value, bouton);
      } catch (e) {
        erreur.textContent = e.message;
        erreur.hidden = false;
      } finally {
        bouton.removeAttribute('aria-busy');
        bouton.disabled = false;
      }
    });
  });

  /* Boutons "Commander" des formules */
  document.addEventListener('click', async (event) => {
    const bouton = event.target.closest('[data-ajout-variante]');
    if (!bouton) return;
    event.preventDefault();
    bouton.setAttribute('aria-busy', 'true');
    try {
      await ajouter(bouton.dataset.ajoutVariante, bouton.dataset.plan, bouton);
    } catch (e) {
      // Repli : la fiche produit avec la formule présélectionnée
      window.location.href = bouton.getAttribute('href') || window.location.href;
    } finally {
      bouton.removeAttribute('aria-busy');
    }
  });

  /* Galerie : vignettes */
  document.querySelectorAll('[data-klapi-galerie]').forEach((slider) => {
    const galerie = slider.parentElement;
    const vignettes = [...galerie.querySelectorAll('[data-vignette]')];
    const piste = slider.querySelector('[data-piste]');
    if (!vignettes.length || !piste) return;
    vignettes.forEach((vignette) =>
      vignette.addEventListener('click', () => slider.aller?.(Number(vignette.dataset.vignette)))
    );
    piste.addEventListener(
      'scroll',
      () => {
        const index = Math.round(piste.scrollLeft / piste.clientWidth);
        vignettes.forEach((v, i) => (i === index ? v.setAttribute('aria-current', 'true') : v.removeAttribute('aria-current')));
      },
      { passive: true }
    );
  });
})();
